export default __webpack_public_path__ + "static/media/friseSmall.f193accf.svg";